const event = new Event('input')

const addListener = function(el, type, fn) {
	el.addEventListener(type, fn, false)
}

const spaceFilter = function(el) {
	// 去除空格
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/\s+/, '')
		el.dispatchEvent(event)
	})
}

const intFilter = function(el) {
	// 只保留数字
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/\D/g, '')
	})
}

const intPointFilter = function(el) {
	// 只保留数字和小数点
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/[^\d.]/g, '')
		el.dispatchEvent(event)
	})
}

const intPoint2Filter = function(el) {
	// 只保留数字和小数点（保留两位小数）
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
		el.dispatchEvent(event)
	})
}

const intOddFilter = function(el) {
	// 只保留奇数
	addListener(el, 'blur', () => {
		el.value = el.value.replace(/\D/g, '')
		if (el.value < 0) el.value = 0
		if (el.value > 0) {
			if (el.value % 2 === 0) el.value--
		}
		el.dispatchEvent(event)
	})
}

const intZHENGFilter = function(el) {
	// 只保留正整数
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/\D/g, '')
		if (el.value < 0) el.value = 0
		el.dispatchEvent(event)
	})
}

const specialFilter = function(el) {
	// 去除特殊符号
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/[\@\#\$\%\^\&\*\(\)\{\}\:\"\L\<\>\?\[\]\~]/)
		el.dispatchEvent(event)
	})
}

const punctuationFilter = function(el) {
	// 去除标点
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g, '')
		el.dispatchEvent(event)
	})
}

const chineseFilter = function(el) {
	// 去除中文
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/[\u4e00-\u9fa5]/g, '')
		el.dispatchEvent(event)
	})
}

const keepChinese = function(el) {
	// 保留中文
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/[^\u4e00-\u9fa5]/gi, '')
		el.dispatchEvent(event)
	})
}

const englishFilter = function(el) {
	// 去除英文
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/[a-zA-Z]/g, '')
		el.dispatchEvent(event)
	})
}

const keepEnglish = function(el) {
	// 保留英文
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/[^a-zA-Z]/gi, '')
		el.dispatchEvent(event)
	})
}

const invoiceLimit = function(el) {
	// 发票限额
	addListener(el, 'keyup', () => {
		el.value = el.value.replace(/\D/g, '')
		if (el.value > 1000) el.value = 1000
		el.dispatchEvent(event)
	})
}

const basicFilter = function(el) {
	// 空格 标点 特殊符号全去
	addListener(el, 'keyup', () => {
		// 去除空格 标点
		el.value = el.value.replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g, '')
		el.value = el.value.replace(/[\'\"\\\/\b\f\n\r\t]/g, '') // 去除转义字符
		el.value = el.value.replace(/[\@\#\$\%\^\&\*\(\)\{\}\:\"\L\<\>\?\[\]\~]/) // 去除特殊符号
		el.dispatchEvent(event)
	})
}

export default {
	bind(el, binding) {
		if (el.tagName.toLowerCase() !== 'input') {
			el = el.getElementsByTagName('input')[0] || el.getElementsByTagName('textarea')[0]
		}
		switch (binding.arg) {
			case 'int': // 整数
				intFilter(el)
				break
			case 'intZHENG': // 整数
				intZHENGFilter(el)
				break
			case 'intPoint': // 数字小数点
				intPointFilter(el)
				break
			case 'intPoint2': // 数字小数点(保留两位小数)
				intPoint2Filter(el)
				break
			case 'intOdd': // 奇数
				intOddFilter(el)
				break
			// case 'price': // 价格
			//     priceFilter(el)
			//     break
			case 'special': // 去特殊字符
				specialFilter(el)
				break
			case 'space': // 去空格
				spaceFilter(el)
				break
			case 'punctuation': // 去标点符号
				punctuationFilter(el)
				break
			case 'chinese': // 去中文
				chineseFilter(el)
				break
			case 'keepChinese': // 中文
				keepChinese(el)
				break
			case 'english': // 去英文
				englishFilter(el)
				break
			case 'keepEnglish': // 英文
				keepEnglish(el)
				break
			case 'invoiceLimit': // 发票限额
				invoiceLimit(el)
				break
			case 'basic': // 标点符号、空格、特殊字符
				basicFilter(el)
				break
			default:
				break
		}
	}
}



// WEBPACK FOOTER //
// ./src/utility/input-filter/inputFilter.js